import styled from 'styled-components'

const Title = styled.h1`
margin-bottom: 30px;
font-family: 'Segoe UI';
`

export { Title }